import { CheckboxOptionType } from "antd";
import { isEmpty, values } from "lodash";
import { ChangeEvent } from "react";

export const checkIfObjectFieldsAreEmpty = (object: object | undefined) => {
  return object ? values(object).every(isEmpty) : true;
};

export const checkIfSomeObjectFieldsAreFilled = (
  object: object | undefined
) => {
  return object
    ? values(object).some(
        (field) =>
          (!Array.isArray(field) && Boolean(field)) ||
          (Array.isArray(field) &&
            (field as Array<any>).every((el) => Boolean(el)))
      )
    : false;
};

export function isDivisible({
  dividend,
  divisor,
}: {
  dividend: number;
  divisor: number;
}) {
  if (isNaN(dividend) || isNaN(divisor)) {
    return false;
  }

  if (divisor === 0) {
    return false;
  }

  return dividend % divisor === 0;
}

export const compareCheckboxOptionsDeep = (
  a: Array<CheckboxOptionType>,
  b: Array<CheckboxOptionType>
) => {
  if (a.length !== b.length) return false;

  return a.every(
    (option, index) =>
      option.value === b[index].value && option.label === b[index].label
  );
};

export const clearNonNumericValues = (
  event: React.KeyboardEvent<HTMLInputElement>,
  allowedKeys: string[] = []
) => {
  const key = event.key;

  if (
    event.getModifierState("Meta") ||
    event.getModifierState("Control") ||
    event.getModifierState("Alt")
  ) {
    return;
  }

  if (key.length !== 1 || key === "\x00") {
    return;
  }

  if ((key < "0" || key > "9") && !allowedKeys.includes(key)) {
    event.preventDefault();
  }
};

export const clearSpecialCharacters = (
  event: React.KeyboardEvent<HTMLInputElement>,
  allowedKeys: string[] = []
) => {
  const key = event.key;

  if (
    event.getModifierState("Meta") ||
    event.getModifierState("Control") ||
    event.getModifierState("Alt")
  ) {
    return;
  }

  if (key.length !== 1 || key === "\x00") {
    return;
  }

  const isAlphanumeric = /^[a-zA-Z0-9]$/.test(key);
  const isAllowedExtra = allowedKeys.includes(key);

  if (!isAlphanumeric && !isAllowedExtra) {
    event.preventDefault();
  }
};

const escapeForRegex = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const handlePaste = (
  e: {
    clipboardData: { getData: (key: string) => string };
    preventDefault: () => void;
  },
  allowedChars: string[] = []
) => {
  const pasteData = e.clipboardData.getData("text");

  const escapedAllowed = allowedChars.map(escapeForRegex).join("");

  const regex = new RegExp(`^[a-zA-Z0-9${escapedAllowed}]*$`);

  if (!regex.test(pasteData)) {
    e.preventDefault();
  }
};

export const clearDoubleSpaceDot = (
  event: ChangeEvent<HTMLInputElement> | undefined
) => {
  if (!event || !event.target) return;

  if (typeof event.target.value === "string") {
    event.target.value = event.target.value.replace(/ /g, "");
    event.target.value = event.target.value.replace(/\./g, "");
  }
};
